import { render, staticRenderFns } from "./QRegistrationEmail.vue?vue&type=template&id=2c473859&scoped=true&lang=pug&"
import script from "./QRegistrationEmail.vue?vue&type=script&lang=ts&"
export * from "./QRegistrationEmail.vue?vue&type=script&lang=ts&"
import style0 from "./QRegistrationEmail.vue?vue&type=style&index=0&id=2c473859&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c473859",
  null
  
)

component.options.__file = "QRegistrationEmail.vue"
export default component.exports